import styled from 'styled-components'
import React from 'react'
import { hexToRgba } from '~/utils'

const StyledCate = styled.ul<{ hideBorder?: boolean; theme: any }>`
  position: relative;
  padding: 0;
  margin: 0 0 16px 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid
    ${props => (props.hideBorder ? 'transparent' : props.theme.light1)};
  white-space: nowrap;
  > li {
    font-size: 16px;
    line-height: 24px;
    padding: 6px 12px;
    margin-right: 16px;
    margin-bottom: 16px;
    background: none;
    font-weight: 600;
    color: ${props => props.theme.dark4};
    border-radius: 100px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      transition: all 0.3s ease;
      color: ${props => props.theme.dark2};
    }
    &.active {
      color: ${props => props.theme.light3};
      background: ${props => props.theme.dark3};
    }
  }
`

const StyledSubCate = styled.ul`
  margin: 0 0 8px 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  > li {
    font-size: 14px;
    line-height: 16px;
    padding: 8px 12px;
    color: ${props => props.theme.dark4};
    background: ${props => props.theme.light2};
    font-weight: 600;
    border-radius: 90px;
    margin-right: 8px;
    margin-bottom: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      transition: all 0.3s ease;
      color: ${props => props.theme.dark2};
    }
    &.active {
      color: ${props => props.theme.primaryColor};
      background: ${props => hexToRgba(props.theme.primaryColor, 0.1)};
    }
  }
`

export interface CateDataProps {
  id: number | string
  name: string
  categoryList?: CateDataProps[]
}

export const MyTab: React.FC<{
  menu: CateDataProps[]
  active: number
  activeSub?: number[]
  onChange: (val: number) => void
  onSubChange?: (val: number) => void
  hideSubMenu?: boolean
  hideBorder?: boolean
}> = ({
  menu,
  active,
  activeSub = [],
  onChange,
  onSubChange,
  hideSubMenu,
  hideBorder,
}) => {
  return (
    <>
      <StyledCate hideBorder={hideBorder}>
        {menu.map((item, index) => (
          <li
            key={item.id}
            onClick={() => onChange(index)}
            className={index == active ? 'active' : ''}
          >
            {item.name}
          </li>
        ))}
      </StyledCate>
      {!hideSubMenu && menu[active]?.categoryList?.length ? (
        <StyledSubCate>
          {menu[active].categoryList?.map(item => (
            <li
              key={item.id}
              className={
                activeSub?.includes(item.id as number) ||
                (item.id < 0 && !activeSub?.length)
                  ? 'active'
                  : ''
              }
              onClick={() => onSubChange && onSubChange(item.id as number)}
            >
              {item.name}
            </li>
          ))}
        </StyledSubCate>
      ) : (
        ''
      )}
    </>
  )
}
